import api from './api';

export const streamService = {
  getSettings: () => api.get('/settings'),
  getBanners: () => api.get('/banners/active'),
  getEvents: (params) => api.get('/events', { params }),
  getEventById: (id) => api.get(`/events/${id}`),
};
